import styled from "styled-components";

export const Container = styled.div`
  position: relative;
  margin: 0.5rem 0rem;
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.01);
  border-radius: 1rem;
  flex: 1;
  width: 100%;
  padding: 1.5rem;
`;
export const NotiPoint = styled.span`
  width: 1rem;
  height: 1rem;
  border-radius: 9999px;
  background-color: red;
  position: absolute;
  bottom: 2rem;
  right: 2rem;
`;
export const ContainerHeaderCard = styled.div`
  width: 100%;
  display: flex;
`;

export const AvatarProfile = styled.img`
  width: 3rem;
  height: 3rem;
  border-radius: 3rem;
`;
export const ContainerDetailProfile = styled.div`
  padding-left: 1rem;
  align-self: center;
  & > h4 {
    margin: 0;
    color: #123559;
    text-align: start;
  }
  & > p {
    margin: 0;
    color: #808080;
    text-align: start;
    font-weight: 200;
    & > span {
      font-weight: 300;
      margin-right: 0.25rem;
    }
  }
`;
export const LastChat = styled.p`
  color: #808080;
  text-align: start;
  margin: 1rem 1.5rem 0 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4; /* number of lines to show */
  -webkit-box-orient: vertical;
`;
export const TextDate = styled.p`
  color: #808080;
  text-align: start;
  font-weight: 200;
  font-size: 0.75rem;
  margin: 0 1.5rem;
`;
export const TextDetail = styled.p`
  color: #808080;
  text-align: start;
  font-weight: 200;
  margin: 0 1.5rem;
  margin-top: 1rem;
  & > span {
    font-weight: 300;
    margin-right: 1rem;
  }
`;
